// tslint:disable-next-line:no-reference
/// <reference path="../../../../node_modules/@types/jqueryui/index.d.ts" />
// tslint:disable-next-line:no-reference
/// <reference path="./pivottable.d.ts" />
// tslint:disable-next-line: no-reference
/// <reference path="./domtoimage.d.ts" />
import { WithGlobalCss } from "@sgwt-widget/core";
import * as $ from "jquery";
import "pivottable";
import { Component, h } from "preact";
import "../../../../node_modules/jquery-ui/ui/widgets/datepicker.js";
import "../../../../node_modules/jquery-ui/ui/widgets/sortable.js";
import "../../../../node_modules/jquery-ui/ui/widgets/tooltip.js";
import { htmlToExcel } from "../../generic/export-helper";
import { C3Renderes, TableRenderers } from "./C3Renderers";
import * as css from "./pivotchart.less";
// tslint:disable-next-line:no-var-requires
const domtoimage = require("dom-to-image");
import { isEqual } from "lodash";
import { IAttribute } from "../../generic/generic-explore-indicators";
import { INewPivotTableOptions } from "../../utils/types";

interface IReactPivotProps {
  data: any[];
  defaultColumns: string[];
  defaultRows: string[];
  tableHeaders: IAttribute[];
  renderer: string;
  aggregators: IAttribute[];
  aggregatorName: string;
  jsonData: any[];
  spinnerClass: string;
  exclusions: {};
  advanceShown: boolean;
  sorters?: {};
  unitSymbol: string;
  rowOrder?: string;
  colOrder?: string;
  onPivotTableOptionsChanged(options: INewPivotTableOptions): void;
}

interface IState {
  cols?: string[];
  rows?: string[];
  aggregatorName?: string;
  rendererName?: string;
  exclusions?: any;
}
export class PivotTableWithChart extends Component<IReactPivotProps, IState> {
  private divElement?: HTMLDivElement;
  constructor() {
    super();
    this.onBtnExport = this.onBtnExport.bind(this);
    this.configChanged = this.configChanged.bind(this);
    this.setState({
      cols: [],
      rows: [],
    });
  }

  public componentDidMount() {
    this.createPivotTable();
  }

  public componentDidUpdate() {
    this.createPivotTable();
  }

  public shouldComponentUpdate(
    nextProps: IReactPivotProps,
    nextState: any,
    nextContext: any
  ): boolean {
    return !isEqual(this.props, nextProps);
  }

  public render() {
    return (
      <WithGlobalCss styles={css}>
        <button
          style="margin-left: 10px;"
          class="btn btn-default"
          onClick={(x: any) => this.onBtnExport(x)}
        >
          <span class="fa fa-file-excel-o" /> Export
          <i class={this.props.spinnerClass} />
        </button>
        <div
          id="pivotchartoutputui"
          style="height: 100%; width: 100%"
          class={`${css.locals.pivottable}`}
          ref={e => (this.divElement = e as HTMLDivElement)}
        />
        <label>
          <b>Units:</b>
          {this.props.unitSymbol}
        </label>
      </WithGlobalCss>
    );
  }

  private hideAdvancedMode() {
    if (this.divElement) {
      const pvtAxisContainer = this.divElement.getElementsByClassName(
        "pvtAxisContainer"
      ) as HTMLCollectionOf<HTMLElement>;
      this.InitializeShowHideElement(pvtAxisContainer);

      const pvtVals = this.divElement.getElementsByClassName(
        "pvtVals"
      ) as HTMLCollectionOf<HTMLElement>;
      this.InitializeShowHideElement(pvtVals);

      const pvtRenderer = this.divElement.getElementsByClassName(
        "pvtRenderer"
      ) as HTMLCollectionOf<HTMLElement>;
      this.InitializeShowHideElement(pvtRenderer);
    }
  }

  private InitializeShowHideElement(cols: HTMLCollectionOf<HTMLElement>) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < cols.length; i++) {
      if (this.props.advanceShown) {
        cols[i].style.display = "";
      } else {
        cols[i].style.display = "none";
      }
    }
  }

  private createPivotTable() {
    this.setState({
      aggregatorName: this.props.aggregatorName,
      cols: this.props.defaultColumns,
      rendererName:
        this.props.renderer === undefined
          ? "Horizontal Bar Chart"
          : this.props.renderer,
      rows: this.props.defaultRows,
    });
    const object = new C3Renderes();
    const renderers =
      this.props.jsonData.length === 0 ||
      (this.props.jsonData.length > 0 &&
        this.props.jsonData.length *
          Object.keys(this.props.jsonData[0]).length >=
          10000)
        ? $.extend(new TableRenderers().tableRenderers, object.c3Renderers)
        : $.extend($.pivotUtilities.renderers, object.c3Renderers);
    let data = this.props.data;
    if (this.props.data.length === 0) {
      data = [Array.apply(null, Array(this.props.tableHeaders.length))];
    }
    const pivotData = [[...this.props.tableHeaders.map(x => x.id)], ...data];
    const tpl = $.pivotUtilities.aggregatorTemplates;
    const numberFormat = $.pivotUtilities.numberFormat;
    const intFormat = numberFormat({
      digitsAfterDecimal: 0,
    });
    const aggregators: { [index: string]: () => any } = {};
    for (const item of this.props.aggregators) {
      aggregators[item.name] = () => {
        return tpl.sum(intFormat)([item.id]);
      };
    }
    const derivedAttrs: { [inex: string]: (x: any) => any } = {};

    this.props.tableHeaders.forEach((x: any) => {
      if (
        this.props.aggregators.map((y: any) => y.name).indexOf(x.name) === -1
      ) {
        derivedAttrs[x.name] = (y: any) => {
          return y[x.id];
        };
      }
    });
    $(this.divElement as HTMLDivElement).pivotUI(
      pivotData,
      {
        aggregatorName: this.props.aggregatorName,
        aggregators,
        colOrder: this.props.colOrder,
        cols: this.props.defaultColumns,
        derivedAttributes: derivedAttrs,
        exclusions: this.props.exclusions,
        hiddenAttributes: this.props.tableHeaders.map(x => x.id),
        onRefresh: (options: PivotUiOptions) => {
          this.configChanged(options);
        },
        rendererName:
          this.props.renderer === undefined
            ? "Horizontal Bar Chart"
            : this.props.renderer,
        rendererOptions: {
          c3: { size: { width: 480, height: 360 } },
        },
        renderers,
        rowOrder: this.props.rowOrder,
        rows: this.props.defaultRows,
        sorters:
          this.props.rowOrder || this.props.colOrder
            ? {
                Month: $.pivotUtilities.sortAs([
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ]),
              }
            : "",
        vals: [this.props.unitSymbol],
      },
      true
    );
    this.hideAdvancedMode();
    $(".pvtTriangle").empty();
  }

  private configChanged(options: PivotUiOptions) {
    this.setState({
      aggregatorName: options.aggregatorName,
      cols: options.cols,
      exclusions: options.exclusions,
      rendererName: options.rendererName,
      rows: options.rows,
    });
    this.props.onPivotTableOptionsChanged({
      aggregatorName: options.aggregatorName as string,
      colOrder: options.colOrder,
      cols: options.cols as string[],
      exclusions: options.exclusions as {},
      rendererName: options.rendererName ? options.rendererName : "",
      rowOrder: options.rowOrder,
      rows: options.rows as string[],
      title: "",
    });
  }

  private onBtnExport(event: any) {
    if (
      this.state.rendererName === "Table" ||
      this.state.rendererName === "Table Barchart"
    ) {
      htmlToExcel(
        event.target.parentNode.parentNode.getElementsByClassName(
          "pvtRendererArea"
        )[0],
        "InteractiveTable"
      );
    } else {
      const node = event.target.parentNode.parentNode.getElementsByClassName(
        "pvtRendererArea"
      )[0];
      domtoimage
        .toJpeg(node, {
          bgcolor: "white",
          quality: 0.95,
        })
        .then((dataUrl: any) => {
          const link = document.createElement("a");
          link.download = "interactiveChart.jpeg";
          link.href = dataUrl;
          link.click();
        });
    }
  }
}
